import _map from 'lodash/map';

import { IPropsWithClassName } from 'interfaces';
import { ButtonProps } from '@atoms/Button';

import styles from './styles';

export interface SelectorProps extends IPropsWithClassName {
  items: ButtonProps[];
  onChange(item: string): void;
  selected: string;
  tabbable?: boolean;
}

const Selector = ({
  items,
  onChange,
  selected,
  tabbable = true,
  className,
}: SelectorProps) => {
  const componentStyles = styles.component(className);

  const makeOption = (props: ButtonProps) => (
    <option
      key={String(props.children)}
      value={String(props.children)}
    >
      {String(props.children).toLowerCase()}
    </option>
  );
  const options = _map(items, (item) => makeOption(item));
  const extraProps:{
    tabIndex?: number,
  } = {};

  if (!tabbable) {
    extraProps.tabIndex = -1;
  }

  return (
    <div className="select-arrow relative">
      <select
        className={componentStyles}
        name="select"
        onChange={(event) => {
          onChange(event.target.value);
        }}
        value={selected}
        {...extraProps}
      >
        {options}
      </select>
    </div>
  );
};

export default Selector;
